/* import __COLOCATED_TEMPLATE__ from './group-flair-inputs.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import { action } from "@ember/object";
import $ from "jquery";
import { ajax } from "discourse/lib/ajax";
import discourseDebounce from "discourse-common/lib/debounce";
import getURL from "discourse-common/lib/get-url";
import { convertIconClass } from "discourse-common/lib/icon-library";
import discourseComputed, { observes, on } from "discourse-common/utils/decorators";
import I18n from "discourse-i18n";
import TEMPLATE from "./group-flair-inputs.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend(dt7948.p({
  classNames: ["group-flair-inputs"],
  demoAvatarUrl() {
    return getURL("/images/avatar.png");
  },
  flairPreviewIcon(flairType) {
    return flairType && flairType === "icon";
  },
  flairPreviewIconUrl(flairIcon) {
    return flairIcon ? convertIconClass(flairIcon) : "";
  },
  _loadSVGIcon(flairIcon) {
    if (flairIcon) {
      discourseDebounce(this, this._loadIcon, 1000);
    }
  },
  _loadIcon() {
    if (!this.model.flair_icon) {
      return;
    }
    const icon = convertIconClass(this.model.flair_icon),
      c = "#svg-sprites",
      h = "ajax-icon-holder",
      singleIconEl = `${c} .${h}`;
    if (!icon) {
      return;
    }
    if (!$(`${c} symbol#${icon}`).length) {
      ajax(`/svg-sprite/search/${icon}`).then(function (data) {
        if ($(singleIconEl).length === 0) {
          $(c).append(`<div class="${h}">`);
        }
        $(singleIconEl).html(`<svg xmlns='http://www.w3.org/2000/svg' style='display: none;'>${data}</svg>`);
      });
    }
  },
  flairPreviewImage(flairType) {
    return flairType && flairType === "image";
  },
  flairImageUrl(flairUrl) {
    return flairUrl && flairUrl.includes("/") ? flairUrl : null;
  },
  flairPreviewLabel(flairPreviewImage) {
    const key = flairPreviewImage ? "image" : "icon";
    return I18n.t(`groups.flair_preview_${key}`);
  },
  setFlairImage(upload) {
    this.model.setProperties({
      flair_url: getURL(upload.url),
      flair_upload_id: upload.id
    });
  },
  removeFlairImage() {
    this.model.setProperties({
      flair_url: null,
      flair_upload_id: null
    });
  }
}, [["method", "demoAvatarUrl", [discourseComputed]], ["method", "flairPreviewIcon", [discourseComputed("model.flair_type")]], ["method", "flairPreviewIconUrl", [discourseComputed("model.flair_icon")]], ["method", "_loadSVGIcon", [observes("model.flair_icon"), on("didInsertElement")]], ["method", "flairPreviewImage", [discourseComputed("model.flair_type")]], ["method", "flairImageUrl", [discourseComputed("model.flair_url")]], ["method", "flairPreviewLabel", [discourseComputed("flairPreviewImage")]], ["method", "setFlairImage", [action]], ["method", "removeFlairImage", [action]]])));